<main class="main">
  <h2 mat-dialog-title class="main--title">{{ 'forgotPassword' | i18next }}</h2>
  <mat-dialog-content>
    <p class="main--text" *ngIf="data.group !== 'EXTERNVO'">
      {{ 'forgotPasswordText' | i18next }}
    </p>
    <p class="main--text" *ngIf="data.group === 'EXTERNVO'">
      {{ 'forgotPasswordTextVO' | i18next }}
    </p>
    <form [formGroup]="forgotPasswordForm" class="main--form">
      <mat-form-field *ngIf="data.group !== 'EXTERNVO'">
        <mat-label for="nis">{{ 'nis' | i18next }}</mat-label>
        <input
          matInput
          type="text"
          name="nis"
          (change)="errorMsg('nis')"
          maxlength="6"
          placeholder="{{ 'nis' | i18next }}"
          formControlName="nis"
          #autofocus
        />
      </mat-form-field>
      <mat-form-field *ngIf="data.group === 'EXTERNVO'">
        <mat-label for="nis">{{ 'nif' | i18next }}</mat-label>
        <input
          matInput
          type="text"
          name="nis"
          maxlength="9"
          placeholder="{{ 'nif' | i18next }}"
          formControlName="nis"
          #autofocus
        />
      </mat-form-field>
    </form>
    <div>
      <p
        class="error-message"
        *ngIf="forgotPasswordForm.invalid && forgotPasswordForm.touched"
        [ngClass]="errorMsg('nis')"
      >
        {{ 'inputInvalid' | i18next | uppercase }}
      </p>
      <p class="error-message">{{ errorMessage }}</p>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="btnContainer">
    <button
      class="btnContainer--btnCancel btn cancel"
      mat-button
      mat-dialog-close
    >
      {{ 'btnCancel' | i18next | uppercase }}
    </button>
    <button
      class="btnContainer--btn btn confirmDark"
      mat-button
      (click)="onSubmit()"
    >
      {{ 'btnContinue' | i18next | uppercase }}
    </button>
    <div class="text-center spinner-container mg-left" *ngIf="spinner">
      <div class="spinner-border spinner" role="status"></div>
    </div>
  </mat-dialog-actions>
</main>
